import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";

export const SIDEBAR_OPEN = "260px";
export const SIDEBAR_CLOSE = "72px";

export const SecondRowShow = styled(Collapse)`
`;

export const CustomLink = styled.span`
    color: #1d4ed8;
    font-weight: 600;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: #2563eb;
    }
`;

export const OrderHeaderStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-block: 10px;
    justify-content: flex-end;
`;

export const HeaderButtons = styled(Box)`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
`;
export const CustomScheduleTitle = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 6px;
    width: 100%;

    span {
        font-size: 16px;
    }
`;
export const MainHeader = styled(Box)`
    height: 60px;
    width: 100% !important;
    position: sticky !important;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: 16px;
    background-color: #ffffff;
    z-index: 20;
    -webkit-box-shadow: 0px 4px 8px -6px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0px 4px 8px -6px rgba(34, 60, 80, 0.2);
    box-shadow: 0px 4px 8px -6px rgba(34, 60, 80, 0.2);

    h2 {
        color: #0f172a;
    }
`;

export const ErrorLabelStyle = styled.div`
    color: #dc2626;
    font-size: 12px;
`;

export const ImgUploadStyled = styled(Box)`
    position: relative;
    width: 120px;
    height: 110px;
    border-radius: 10px;
    background-color: #eef2ff;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex-direction: column;

    label {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        input {
            opacity: 0;
            z-index: -1;
        }
    }

    .imageBox {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
        }

        .deleteIcon {
            z-index: -1;
            opacity: 0;
            transition: all 0.3s ease;
            position: absolute;
            width: 35px;
            height: 35px;
            background-color: #ffffff;
        }
    }

    &:hover {
        .imageBox {
            .deleteIcon {
                z-index: 2;
                opacity: 1;
            }
        }
    }

    .loading {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(15, 23, 42, 0.08);
    }
`;

export const ScheduleHoverBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    .item {
        display: flex;
        justify-content: space-between;
        gap: 7px;
        max-width: 300px;

        code {
            font-size: 13px;
            font-weight: 600;
            color: #6b7280;
        }

        p {
            font-size: 13px;
            font-weight: 700 !important;
            width: 180px;
            color: #2563eb;
        }
    }
`;

export const AppBar = styled.div`
    transition: all 0.3s ease;

    * {
        ::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }

        ::-webkit-scrollbar-thumb {
            background-color: #cbd5f5;
            border-radius: 12px;
        }

        ::-webkit-scrollbar-track {
            background-color: #e2e8f0;
        }
    }

    body {
        background-color: #f5f7fb;
    }

    .main-container {
        min-height: 100%;
        animation: animate 0.3s linear;
    }

    @keyframes animate {
        0% {
            filter: brightness(92%);
        }
        100% {
            filter: brightness(100%);
        }
    }
`;


export const PrintIconButton = styled(IconButton)`
    width: 40px !important;
    height: 40px !important;
    border-radius: 6px !important;
    background-color: #edf2ff !important;
`;


